import { render, staticRenderFns } from "./IconAudioToggle.vue?vue&type=template&id=35add23c&scoped=true"
import script from "./IconAudioToggle.vue?vue&type=script&lang=js"
export * from "./IconAudioToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35add23c",
  null
  
)

export default component.exports